import { CHCTable } from "./table.component.js";
customElements.define("chc-table", CHCTable);
export {
  CHCTable
};
//# sourceMappingURL=table.js.map
